import { render } from "./languageSwitcher.vue?vue&type=template&id=68e7ff16"
import script from "./languageSwitcher.vue?vue&type=script&lang=js"
export * from "./languageSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mobilemediaru/cashforapp/cashforapp_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__